import { Outlet } from "react-router-dom";
import { SectionTabs } from "@/components/SectionTabs";
import { MenuLateral, MenuMobile } from "@/components/MenuNav";
import { LayoutDashboard, Upload, GitMerge, Receipt, FileDown, Settings, LogOut, Landmark, CalendarRange, BookOpenCheck, Search, SlidersHorizontal, MessageSquareText, Send, FolderOpen, CalendarDays, Building2, ArrowLeftRight, Percent, Scale, Calculator } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ReservationSearch } from "@/components/ReservationSearch";

const NAV = [
  { to: "/", label: "Tableau de bord", icon: LayoutDashboard, id: "dashboard" },
  { to: "/imports", label: "Imports", icon: Upload, id: "imports" },
  { to: "/fichiers", label: "Fichiers", icon: FolderOpen, id: "fichiers" },
  { to: "/rapprochement", label: "Rapprochement", icon: GitMerge, id: "rapprochement" },
  { to: "/reservations", label: "Réservations & taxes", icon: Receipt, id: "reservations" },
  { to: "/calcul-reservation", label: "Calculer une réservation", icon: Calculator, id: "calcul-reservation" },
  { to: "/calendrier", label: "Calendrier", icon: CalendarDays, id: "calendrier" },
  { to: "/comparaison", label: "Comparaison de mois", icon: CalendarRange, id: "comparaison" },
  { to: "/bilan", label: "Bilan annuel", icon: BookOpenCheck, id: "bilan" },
  { to: "/appartements", label: "Bilan par appartement", icon: Building2, id: "appartements" },
  { to: "/recherche", label: "Recherche relevés", icon: Search, id: "recherche" },
  { to: "/commentaires", label: "Commentaires opérations", icon: MessageSquareText, id: "commentaires" },
  { to: "/declaration-taxes", label: "Déclaration TPS & TVQ", icon: Percent, id: "declaration-taxes" },
  { to: "/conciliation-bancaire", label: "Conciliation bancaire", icon: Scale, id: "conciliation-bancaire" },
  { to: "/reaffecter", label: "Réaffecter les opérations", icon: ArrowLeftRight, id: "reaffecter" },
  { to: "/exports", label: "Exports comptables", icon: FileDown, id: "exports" },
  { to: "/envoi-comptable", label: "Envoi au comptable", icon: Send, id: "envoi-comptable" },
  { to: "/plateformes", label: "Paramètres plateformes", icon: SlidersHorizontal, id: "plateformes" },
  { to: "/parametres", label: "Paramètres", icon: Settings, id: "parametres" },
];

const linkCls = ({ isActive }) =>
  `group flex items-center gap-3 rounded-md px-3 py-2 text-sm font-medium transition-colors duration-150 ${
    isActive ? "bg-emerald-500/15 text-emerald-300" : "text-slate-400 hover:bg-white/5 hover:text-white"
  }`;

const Brand = () => (
  <div className="flex items-center gap-2.5">
    <div className="h-8 w-8 rounded-md bg-emerald-600 grid place-items-center">
      <Landmark className="h-4 w-4 text-white" />
    </div>
    <div className="leading-tight">
      <p className="text-sm font-bold text-white tracking-tight">Rapproch.</p>
      <p className="text-[10px] font-mono uppercase tracking-widest text-slate-500">Airbnb · Booking</p>
    </div>
  </div>
);

export default function Layout() {
  const { user, signOut } = useAuth();
  return (
    <div className="min-h-screen lg:flex">
      <aside className="hidden lg:flex w-[17rem] shrink-0 flex-col bg-slate-950 px-4 py-6 sticky top-0 h-screen" data-testid="sidebar">
        <Brand />
        <div className="mt-6"><ReservationSearch /></div>
        <MenuLateral nav={NAV} linkCls={linkCls} />
        <div className="mt-4 shrink-0 border-t border-white/10 pt-4">
          <p className="truncate text-xs text-slate-400" data-testid="sidebar-user-email">{user?.email}</p>
          <button
            onClick={signOut}
            className="mt-2 flex items-center gap-2 text-xs text-slate-500 hover:text-white transition-colors"
            data-testid="logout-button"
          >
            <LogOut className="h-3.5 w-3.5" /> Se déconnecter
          </button>
        </div>
      </aside>
      <header className="lg:hidden bg-slate-950 px-4 pt-4 pb-2 sticky top-0 z-30">
        <div className="flex items-center justify-between">
          <Brand />
          <button onClick={signOut} className="text-slate-400" data-testid="mobile-logout-button">
            <LogOut className="h-4 w-4" />
          </button>
        </div>
        <div className="mt-3"><ReservationSearch testId="mobile-resa-search" /></div>
        <MenuMobile nav={NAV} linkCls={linkCls} />
      </header>
      <main id="contenu-principal" className="flex-1 min-w-0 px-4 py-6 sm:px-8 lg:px-10 lg:py-10">
        <SectionTabs />
        <Outlet />
      </main>
    </div>
  );
}
